import moment from 'moment';
import { DATE_FORMAT, DATE_FORMAT_REQ, TIME_FORMAT } from '../appConstants';

export const formatDate = date => moment(date).format(DATE_FORMAT);
export const formatDateReq = date => moment(date).format(DATE_FORMAT_REQ);
export const formatTime = time => moment(time).format(TIME_FORMAT);
